import client, { ApiResponse } from './client';

export interface AdConfig {
  adId: number; // Changed to number
  type?: 'video' | 'banner'; // Old field, maybe keep as optional
  adType?: 'rewarded_video' | string; // New field from backend
  provider: 'admob' | 'unity' | 'custom' | string;
  minDuration: number;
  reward: number;
  dailyLimit?: number;
  todayCount?: number;
  canWatch?: boolean;
  mediaUrl?: string | null;
  mediaType?: 'image' | 'video';
  description?: string;
  title?: string;
  linkUrl?: string | null;
  name?: string;
  placementId?: string;
}

export interface AdStartResponse {
  success: boolean;
  adRecordId: number;
}

export interface AdEndResponse {
  success: boolean;
  claimToken?: string;
}

export interface AdClaimResponse {
  success: boolean;
  reward: number;
}

export const getAdConfig = async (): Promise<AdConfig> => {
  const response = await client.get<ApiResponse<AdConfig>>('/ads/config');
  return response.data.data;
};

export const recordAdStart = async (placementId: string): Promise<number> => {
  const response = await client.post<any>('/ads/record-start', {
    placementId,
  });
  // Handle both standard ApiResponse structure and flat structure
  const data = response.data;
  if (data.data && data.data.adRecordId !== undefined) {
    return data.data.adRecordId;
  }
  return data.adRecordId;
};

export const reportAdEnd = async (adRecordId: number, duration: number): Promise<string | undefined> => {
  const response = await client.post<any>('/ads/report-end', {
    adRecordId,
    duration,
  });
  const data = response.data;
  if (data.data && data.data.claimToken !== undefined) {
    return data.data.claimToken;
  }
  return data.claimToken;
};

export const claimAdReward = async (adRecordId: number, claimToken: string): Promise<number> => {
  const response = await client.post<any>('/ads/claim', {
    adRecordId,
    claimToken,
  });
  const data = response.data;
  if (data.data && data.data.reward !== undefined) {
    return data.data.reward;
  }
  return data.reward;
};
